module.exports = __webpack_public_path__ + "img/chuang2.61e6dd5b.png";